import { cn } from "@oneleet/utils";

export const CircleApp = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-6", className)}
    >
      <g clipPath="url(#clip0_2499_21264)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="url(#paint0_linear_2499_21264)"
        />
        <g clipPath="url(#clip1_2499_21264)">
          <path
            d="M22.615 12C22.615 17.8625 17.8625 22.615 12 22.615C6.13754 22.615 1.38501 17.8625 1.38501 12C1.38501 12.0025 12 1.38499 12 1.38499C17.8625 1.38499 22.615 6.13753 22.615 12Z"
            fill="#0052B4"
          />
          <path
            d="M12.0002 1.38499C11.9995 1.38499 11.9988 1.38504 11.9982 1.38504L12.0002 1.38499Z"
            fill="#F0F0F0"
          />
          <path
            d="M11.9716 12H12C12 11.9904 12 11.9812 12 11.9716C11.9905 11.9811 11.9811 11.9905 11.9716 12Z"
            fill="#F0F0F0"
          />
          <path
            d="M12 6.92329C12 5.05551 12 3.83159 12 1.38504H11.9982C6.13655 1.38599 1.38501 6.13807 1.38501 12H6.92326V8.88134L10.0419 12H11.9716C11.9811 11.9905 11.9906 11.9811 12.0001 11.9716C12.0001 11.2565 12.0001 10.6183 12.0001 10.042L8.88136 6.92329H12Z"
            fill="#F0F0F0"
          />
          <path
            d="M6.7553 2.76955C5.09509 3.7149 3.71489 5.0951 2.76953 6.75531V12H5.53868V5.53873V5.53869H12C12 4.66532 12 3.83329 12 2.76955H6.7553Z"
            fill="#D80027"
          />
          <path
            d="M11.9999 10.6946L8.22857 6.92333H6.92322C6.92322 6.92329 6.92322 6.92333 6.92322 6.92333L11.9999 12H11.9999C11.9999 12 11.9999 11.1 11.9999 10.6946Z"
            fill="#D80027"
          />
          <path
            d="M14.5351 9.23091L14.8263 9.84003L15.4841 9.68794L15.1895 10.2954L15.7185 10.7149L15.0599 10.8634L15.0617 11.5385L14.5351 11.1161L14.0084 11.5385L14.0101 10.8634L13.3516 10.7149L13.8805 10.2954L13.586 9.68794L14.2438 9.84003L14.5351 9.23091Z"
            fill="#F0F0F0"
          />
          <path
            d="M17.2448 5.53871L17.5361 6.14783L18.1939 5.99578L17.8994 6.60328L18.4283 7.02274L17.7697 7.17122L17.7715 7.84635L17.2448 7.42395L16.7182 7.84635L16.72 7.17122L16.0614 7.02274L16.5903 6.60328L16.2958 5.99578L16.9536 6.14783L17.2448 5.53871Z"
            fill="#F0F0F0"
          />
          <path
            d="M19.6118 8.30785L19.9031 8.91696L20.5609 8.76487L20.2663 9.37237L20.7953 9.79187L20.1367 9.94036L20.1385 10.6154L19.6118 10.1931L19.0851 10.6154L19.0869 9.94036L18.4283 9.79187L18.9573 9.37237L18.6627 8.76487L19.3205 8.91696L19.6118 8.30785Z"
            fill="#F0F0F0"
          />
          <path
            d="M17.9193 11.5385L18.1484 12.2436H18.8899L18.29 12.6795L18.5192 13.3846L17.9193 12.9488L17.3195 13.3846L17.5486 12.6795L16.9487 12.2436H17.6902L17.9193 11.5385Z"
            fill="#F0F0F0"
          />
        </g>
        <path
          d="M19.7142 15.8824C19.7142 16.7826 18.904 17.4726 17.8213 17.4726H17.2004V18.951H15.9965V14.2857H17.8213C18.904 14.2857 19.7142 14.9822 19.7142 15.8824ZM18.5482 15.8824C18.5482 15.5341 18.2377 15.2713 17.8061 15.2713H17.2004V16.4935H17.8061C18.2377 16.4935 18.5482 16.2241 18.5482 15.8824Z"
          fill="white"
        />
        <path
          d="M15.2258 15.8824C15.2258 16.7826 14.4156 17.4726 13.3329 17.4726H12.712V18.951H11.5081V14.2857H13.3329C14.4156 14.2857 15.2258 14.9822 15.2258 15.8824ZM14.0598 15.8824C14.0598 15.5341 13.7493 15.2713 13.3177 15.2713H12.712V16.4935H13.3177C13.7493 16.4935 14.0598 16.2241 14.0598 15.8824Z"
          fill="white"
        />
        <path
          d="M5.25378 18.951L7.55561 14.2857H8.64595L10.9478 18.951H9.69086L9.21384 17.9654H6.98773L6.5107 18.951H5.25378ZM8.10078 15.659L7.41932 17.0586H8.77467L8.10078 15.659Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2499_21264"
          x1="24"
          y1="24"
          x2="0"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#002A5C" />
          <stop offset="1" stopColor="#005FD0" />
        </linearGradient>
        <clipPath id="clip0_2499_21264">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_2499_21264">
          <rect
            width="21.23"
            height="21.23"
            fill="white"
            transform="translate(1.38501 1.38499)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
